import {
  entries,
  fromEntries,
  isPlainObject,
  map,
  pipe,
} from '@vestigas/utils';

import { getUuidOfCustomFieldId } from './getCustomFieldIds';

/**
 * Returns the custom data for a given delivery note or line item.
 * Cleans the custom data field ids to make sure they are valid uuids.
 * @param additionalPartyData - The additional party data to get the custom data from.
 * @returns The custom data for the given delivery note.
 */
export const getCustomData = (additionalPartyData: Record<string, unknown>) => {
  if (!isPlainObject(additionalPartyData)) {
    return {};
  }

  const customData = pipe(
    additionalPartyData,
    entries,
    map(([key, value]) => [getUuidOfCustomFieldId(key), value]),
    fromEntries,
  );

  return customData;
};
